import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '@services/auth.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  /**
   * Constructor
   * @param router
   */
  constructor(private readonly authService: AuthService) {}

  /*
   * Attaches authentication headers to every outgoing HTTP request when the
   * user is logged in. Adds an Authorization Bearer token and a request-type
   * header identifying the client as a web application. Requests that carry
   * the 'skipHttpRequestInterceptor' header bypass auth injection entirely
   * (the header is stripped before forwarding). Requests with 'isloaderDisable'
   * propagate that flag alongside the auth headers so the loading interceptor
   * can suppress the global spinner. 401 handling (refresh-and-retry or logout)
   * is owned entirely by TokenRefreshInterceptor.
   */
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const auths = this.authService.getUserSession();

    // Check if token is available in local storage
    if (auths != null) {
      if (!req.headers.has('skipHttpRequestInterceptor') && req.headers.get('skipHttpRequestInterceptor') != 'true') {
        // Check and add isloaderDisable falg in request headers value
        const headers = req.headers.has('isloaderDisable')
          ? new HttpHeaders({
              'Authorization': 'Bearer ' + auths.token,
              'request-type': 'web',
              'isloaderDisable': req.headers.get('isloaderDisable'),
            })
          : new HttpHeaders({
              'Authorization': 'Bearer ' + auths.token,
              'request-type': 'web',
            });

        return next.handle(req.clone({ headers }));
      }

      // Remove skipHttpRequestInterceptor header
      return next.handle(req.clone({ headers: req.headers.delete('skipHttpRequestInterceptor') }));
    }

    // Handle the case where the token is not available
    return next.handle(req.clone({ headers: req.headers.delete('skipHttpRequestInterceptor') }));
  }
}
